// The support wiki is deployed per region: EU customers authenticate against
// the EU Cognito pool, which only the EU wiki accepts (ENG-356/ENG-366).
export const getSupportBaseUrl = (): string =>
  window.location.hostname.includes("actuateui.eu")
    ? "https://support.actuateui.eu"
    : "https://support.actuateui.net";

export const getSupportUrl = (path = ""): string =>
  `${getSupportBaseUrl()}${path}`;
